module.exports = __webpack_public_path__ + "static/media/model_v041.c24aa1f1.usdz";